/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

/**
 *
 * @class User
 *
 * @brief the model for a user.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class User {

  /** the OID of this user */
  public id:        number;

  /** flag for super users */
  public isAdmin:   boolean;

  /** the user handle */
  public username:  string;

  /** something like the MD5 hash of their password or just blank */
  public password:  string;

  /** their email */
  public email:     string;

  /** first name of user */
  public firstName: string;

  /** last name of user */
  public lastName:  string;

  /** The OAuth (or similar) access token */
  public token:     string;

  public expiryAt:	number;

  public expirySec:	number;

  public refresh: string;

  /** standard constructor, allow for partial user to be given */
  constructor(init = null) {

    if (init) {
      Object.assign(this, init);
    }

  }
}
